import { Typography } from '@mui/material'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import InCardStack from 'components/atoms/container/InCardStack'
import { IconContainer } from 'components/atoms/Icons'
import colors from 'styles/colors'

const NotificationWrapper = ({
  icon,
  title,
  description,
  children,
  containerSx = {}
}) => {
  return (
    <BoxWithBackground
      sx={{
        width: 320,
        paddingX: 12,
        paddingY: 16,
        border: `1px solid ${colors.Grey200}`,
        borderRadius: 3,
        boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.15)',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        ...containerSx
      }}>
      <InCardStack spacing={12}>
        <InCardStack spacing={4} textAlign={'center'}>
          <IconContainer icon={icon} size={56} />
          <Typography variant='h4'>{title}</Typography>
          {description && (
            <Typography variant='body1KindaSmall' color='primary'>
              {description}
            </Typography>
          )}
        </InCardStack>
        {children}
      </InCardStack>
    </BoxWithBackground>
  )
}

export default NotificationWrapper
